// // Components/AccessRequestPopup.jsx
// import React, { useState } from "react";

// const AccessRequestPopup = ({
//   organizationId,
//   onRequestAccess,
//   onRefresh,
//   canRequest = true,
// }) => {
//   // ✅ Check localStorage on init — if already requested, start as submitted
//   const storageKey = `accessRequested_${organizationId}`;
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [errorMsg, setErrorMsg] = useState("");
//   const [alreadyRequested, setAlreadyRequested] = useState(() => {
//     return localStorage.getItem(storageKey) === "true";
//   });

//   const handleRequest = async () => {
//     if (!canRequest || alreadyRequested) return; // ✅ block if already requested
//     setIsSubmitting(true);
//     setErrorMsg("");
//     try {
//       await onRequestAccess();
//       // ✅ Save to localStorage ONLY on success
//       localStorage.setItem(storageKey, "true");
//       setAlreadyRequested(true);
//     } catch (err) {
//       console.error("Access request failed", err);
//       setErrorMsg("Something went wrong, please try again.");
//       setIsSubmitting(false); // re-enable on failure so user can retry
//     }
//   };

//   const handleRefresh = async () => {
//     if (!onRefresh) return;
//     try {
//       await onRefresh();
//     } catch (err) {
//       console.error("Refresh failed", err);
//       setErrorMsg("Could not refresh status. Please try again.");
//     }
//   };

//   // ✅ Disabled if: parent says no, currently submitting, OR already requested
//   const isRequestDisabled = !canRequest || isSubmitting || alreadyRequested;

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "rgba(255, 255, 255, 1)",
//         zIndex: 1050,
//       }}
//     >
//       <div
//         className="modal-dialog"
//         role="dialog"
//         aria-modal="true"
//         aria-labelledby="access-request-title"
//       >
//         <div className="modal-content p-4">
//           <h4 id="access-request-title" className="mb-3 text-center">
//             Thanks for registering for SUSAN
//           </h4>

//           {/* ✅ Message changes based on request state */}
//           <p className="text-center mb-3">
//             {alreadyRequested
//               ? "Your access request has been submitted. Please be patient, approval usually takes up to 2 hours."
//               : canRequest
//               ? "Click below to request access to SUSAN. Approval usually takes up to 2 hours."
//               : "Your access request could not be approved at this time. Please contact ServQual support for assistance."}
//           </p>

//           {errorMsg && (
//             <p className="text-danger text-center mb-2">{errorMsg}</p>
//           )}

//           <div className="d-flex justify-content-center mt-3 gap-2">
//             <button
//               className="btn btn-primary"
//               onClick={handleRequest}
//               disabled={isRequestDisabled}
//             >
//               {/* ✅ Button label reflects state */}
//               {alreadyRequested
//                 ? "Request Submitted ✓"
//                 : isSubmitting
//                 ? "Submitting..."
//                 : "Request Access"}
//             </button>

//             <button
//               className="btn btn-outline-secondary"
//               type="button"
//               onClick={handleRefresh}
//             >
//               Refresh
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AccessRequestPopup;




// Components/AccessRequestPopup.jsx
import React, { useState } from "react";

const AccessRequestPopup = ({
  organizationId,
  accessStatus,        // ✅ "none" | "pending" | "rejected" | "approved"
  onRequestAccess,
  onRefresh,
  canRequest = true,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // ✅ Derive "already requested" from DynamoDB status — NO localStorage
  const alreadyRequested = accessStatus === "pending";
  const isRejected = accessStatus === "rejected";

  const handleRequest = async () => {
    if (!canRequest || alreadyRequested || isSubmitting) return;
    setIsSubmitting(true);
    setErrorMsg("");
    try {
      await onRequestAccess();
      // ✅ No localStorage.setItem — parent setAccessStatus("pending") handles it
    } catch (err) {
      console.error("Access request failed", err);
      setErrorMsg("Something went wrong, please try again.");
      setIsSubmitting(false);
    }
  };

  const handleRefresh = async () => {
    if (!onRefresh) return;
    try {
      await onRefresh();  // ✅ re-fetches from DynamoDB
    } catch (err) {
      console.error("Refresh failed", err);
      setErrorMsg("Could not refresh status. Please try again.");
    }
  };

  // ✅ Disable if: submitting, already pending, or parent blocked it
  const isRequestDisabled = !canRequest || isSubmitting || alreadyRequested || isRejected;

  const getMessage = () => {
    if (alreadyRequested)
      return "Your access request has been submitted. Please be patient, approval usually takes up to 2 hours.";
    if (isRejected)
      return "Your access request could not be approved. Please contact ServQual support for assistance.";
    if (canRequest)
      return "Click below to request access to SUSAN. Approval usually takes up to 2 hours.";
    return "Your access request could not be processed. Please contact ServQual support.";
  };

  const getButtonLabel = () => {
    if (alreadyRequested) return "Request Submitted ✓";
    if (isRejected) return "Request Denied";
    if (isSubmitting) return "Submitting...";
    return "Request Access";
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 1)",
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog" role="dialog" aria-modal="true" aria-labelledby="access-request-title">
        <div className="modal-content p-4">
          <h4 id="access-request-title" className="mb-3 text-center">
            Thanks for registering for SUSAN
          </h4>

          <p className="text-center mb-3">{getMessage()}</p>

          {errorMsg && <p className="text-danger text-center mb-2">{errorMsg}</p>}

          <div className="d-flex justify-content-center mt-3 gap-2">
            <button
              className="btn btn-primary"
              onClick={handleRequest}
              disabled={isRequestDisabled}
            >
              {getButtonLabel()}
            </button>

            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={handleRefresh}
            >
              Refresh
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessRequestPopup;